import Dispatcher from '../dispatcher';
import { CatalogPostcodeActions } from '../constants/catalog_postcode/catalog_postcode_actions';

function showAction() {
	Dispatcher.handleCatalogPostcodeAction({
		type: CatalogPostcodeActions.SHOW
	});
}

function hideAction() {
	Dispatcher.handleCatalogPostcodeAction({
		type: CatalogPostcodeActions.HIDE
	});
}

function showErrorAction() {
	Dispatcher.handleCatalogPostcodeAction({
		type: CatalogPostcodeActions.SHOW_ERROR
	});
}

function hideErrorAction() {
	Dispatcher.handleCatalogPostcodeAction({
		type: CatalogPostcodeActions.HIDE_ERROR
	});
}

export {
	showAction,
	hideAction,
	showErrorAction,
	hideErrorAction,
};